
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogPortal,
  DialogOverlay,
} from "@/components/ui/dialog";
import { WebhookForm } from "./WebhookForm";

interface WebhookConfig {
  url: string;
  method: string;
  headers: { key: string; value: string }[];
  body: string;
}

interface WebhookDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialConfig?: WebhookConfig | null;
  onSaveConfig: (config: WebhookConfig) => void;
}

export const WebhookDialog = ({ 
  open, 
  onOpenChange, 
  initialConfig, 
  onSaveConfig 
}: WebhookDialogProps) => {
  const { t } = useTranslation();

  const handleSaveConfig = (config: WebhookConfig) => {
    onSaveConfig(config);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="z-[15000] bg-black/50" />
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto z-[15001] bg-white border shadow-lg">
          <DialogHeader>
            <DialogTitle className="text-xl font-semibold">
              Webhook Configuration
            </DialogTitle>
            <DialogDescription>
              Configure webhooks to send data to external services when reports are generated.
            </DialogDescription>
          </DialogHeader>
          
          <div className="mt-4">
            <WebhookForm 
              initialConfig={initialConfig}
              onSaveConfig={handleSaveConfig}
            />
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};
